// removed by extract-text-webpack-plugin
module.exports = {"section-wrapper":"main_nav-2M6","no-padding":"main_nav-1mc","section":"main_nav-2yu","fullwidth":"main_nav-2cH"};


//////////////////
// WEBPACK FOOTER
// ../src/components/Section/section.module.scss
// module id = 349
// module chunks = 0